import React, { Component } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import Spinner from '~/components/spinner/spinner';
import LotForm from '~/components/lotForm/lotForm';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import { lotEditValidationSchema } from '../../validation/lot';

export const getLotQuery = gql`
  query lot($id: Int!) {
    lot(id: $id) {
      id
      productId
      isConsolidated
      isSample
      ingredients {
        id
        ingredientId
        amount
        measurementType
        name
        type
      }
      reference
      notes
      status
      startDate
      volume
      permitNumber
      dutyPaid
      transfers {
        id
        name
        type
        tankType
        notes
        vesselDescription
        stepNumber
        transferDate
        status
        completedAt
        location {
          id
          name
        }
        tank {
          id
          name
        }
      }
    }
  }
`;

export const updateLotMutation = gql`
  mutation updateLot(
    $id: Int!
    $reference: String!
    $volume: Int!
    $startDate: String!
    $notes: String
    $dutyPaid: Boolean!
    $permitNumber: String
    $isSample: Boolean!
    $status: String
    $ingredients: [IngredientForLotUpdate]!
  ) {
    updateLot(
      id: $id
      reference: $reference
      volume: $volume
      startDate: $startDate
      dutyPaid: $dutyPaid
      permitNumber: $permitNumber
      isSample: $isSample
      status: $status
      notes: $notes
      ingredients: $ingredients
    ) {
      id
    }
  }
`;

const convertFormValuesIntoUpdateShape = (initialValues, newValues) => {
  const returnValues = { ...newValues };
  returnValues.ingredients = returnValues.ingredients.map((i, idx) => {
    const ingredient = {
      ...i
    };
    delete ingredient.__typename;
    delete ingredient.name;
    delete ingredient.type;
    return ingredient;
  });

  // The ingredients that are copied over to `lotIngredients` have a slightly different shape
  // than the ingredients table. Remove the fields that don't quite match up and repopulate then
  // back on the server
  delete returnValues.transfers;
  delete returnValues.productId;

  return returnValues;
};

export class LotEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same silly update Apollo issue I keep running into
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;
    return (
      <Query
        query={getLotQuery}
        notifyOnNetworkStatusChange
        variables={{ id }}
        onCompleted={onCompleted}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { lot } = data;
          const lotToEdit = {
            ...lot,
            startDate: moment(lot.startDate).format('YYYY-MM-DD'),
            dutyPaid: !!lot.dutyPaid
          };

          return (
            <div className="content">
              <Mutation mutation={updateLotMutation}>
                {(updateLot, { error }) => (
                  <Formik
                    initialValues={lotToEdit}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={lotEditValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateLot({
                          variables: convertFormValuesIntoUpdateShape(lot, values),
                          refetchQueries: ['lot']
                        });
                        history.push(`/lots/${id}?updated=true`);
                      } catch (err) {
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={LotForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(LotEdit);



// WEBPACK FOOTER //
// ./src/containers/lotEdit/lotEdit.jsx